import { LOCALES, DEFAULT_LOCALE } from 'constants/app-config'
import { updateObject } from 'utils/updateObject'
import { LOGOUT } from 'modules/Auth/types'
import {
  SET_APP_DATA,
  SET_DRAWER_STATE,
  SET_I18N,
  SET_TICKETS_COUNTER,
  SET_USER_INFO,
} from 'modules/App/types'

const reg = new RegExp(`(?:\\/)(?:${LOCALES.join('|')})(?:\\/)`)

const drawerStateFromLS = JSON.parse(localStorage.getItem('drawerState'))

const initialState = {
  ticketsCounter: undefined,
  //initial state from localStorage
  drawerState: drawerStateFromLS || {
    opened: false,
    collapsed: false,
  },
  user: {
    balance: { amount: 0, currency: 'RUB' },
  },
  masterUser: null,
  token: null,
  error: null,
  loading: false,
  i18n: global.location.pathname.match(reg)?.[1] || DEFAULT_LOCALE,
  providers: [
    'vk',
    //'instagram',
    'telegram',
    'ok',
    'twitter',
    'facebook',
  ],
}

const setAppData = (state, action) => updateObject(state, action.payload)
const dropUserData = (state) =>
  updateObject(state, {
    ...initialState,
  })

const setTicketCounter = (state, { payload }) =>
  updateObject(state, {
    ticketsCounter: payload,
  })

const setDrawerState = (state, { payload }) => {
  const newState = {
    ...state.drawerState,
    ...payload,
  }
  localStorage.setItem('drawerState', JSON.stringify(newState))
  return updateObject(state, {
    drawerState: newState,
  })
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
    case SET_APP_DATA:
    case SET_I18N:
      return setAppData(state, action)
    case SET_TICKETS_COUNTER:
      return setTicketCounter(state, action)
    case LOGOUT:
      return dropUserData(state)
    case SET_DRAWER_STATE:
      return setDrawerState(state, action)
    default:
      return state
  }
}
export default reducer
